import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import FieldsList from "../../Misc/FieldsList";
import Sortings from "../../Misc/Sortings";
import Filters from "../../Misc/Filters";
import { essenceClass } from "../../../essense";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import Blocker from "../../Misc/Blocker";
import visualState from "../../../visualState";
import { Link } from "react-router-dom";
import ModelListItem from "./ModelListItem";

let searchTimeout = null;

export default class ModelList extends React.Component {
  static contextType = Context;
  static fieldsStorageName = "modelListFields";
  constructor(props) {
    super(props);

    this.state = {
      textSearchValue: "",
      pending: false,
      searchPending: false,
      search: [],
      customListKey: "",
      filters: {
        show: false,
        active: [],
        default: [],
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      fields: {
        all: [],
        active: [],
      },
      sortings: {
        all: [
          {
            id: "byNameAsc",
            active: false,
            title: "По алфавиту",
            value: ["name ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }
  componentDidMount() {
    this.setDefaultFilters();
    this.loadInfo();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.categoryId !== this.props.categoryId) {
      this.setDefaultFilters();
    }
    if (prevProps.listKey !== this.props.listKey) {
      this.setState({ customListKey: this.props.listKey });
    }
  }

  setDefaultFilters = () => {
    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];
      if (this.props.categoryId && this.props.categoryId !== "any") {
        filters.default.push({
          lstr: "(",
          field: "category",
          compare: "EQL",
          value: this.props.categoryId,
          rstr: ")",
        });
      }
      return filters;
    });
  };

  loadInfo = async () => {};

  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };

  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleFields = (changedFields) => {
    localStorage.setItem(this.fieldsStorageName, JSON.stringify(changedFields));
    this.setState((state) => {
      let fields = state.fields;
      fields.active = changedFields;
      return { fields };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  handleSearch = (searchValue) => {
    this.setState({ textSearchValue: searchValue });
    this.setState({ searchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      let search = searchValue
        ? [
            {
              lstr: "(",
              field: "name",
              compare: "IKE",
              value: `%${searchValue}%`,
            },
            {
              field: "subcode",
              compare: "IKE",
              value: `%${searchValue}%`,
              condition: "OR",
              rstr: ")",
            },
          ]
        : [];
      this.setState({
        searchPending: false,
        search,
      });
    }, 1500);
  };

  handleSearchCancell = () => {
    window.clearTimeout(searchTimeout);
    this.setState({
      searchPending: false,
      search: [],
      textSearchValue: "",
    });
  };

  onFinish = () => {
    this.setState({ customListKey: this.context.key() });
  };

  onListLoadStart = () => {
    this.setState({ pending: true });
  };
  onListLoadEnd = () => {
    this.setState({ pending: false });
  };

  render() {
    let filters = (
      <div
        className={`${
          this.state.filters.show ? "d-block" : "d-none"
        }  wide-filters align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
      >
        <Filters
          key={JSON.stringify(this.state.filters.all)}
          changeFn={this.handleFilters}
          filters={this.state.filters.all}
        />
      </div>
    );
    return (
      <>
        <div className="d-flex mb-4">
          <div className="text-nowrap flex-grow-1 mr-2">
            <div className="input-group">
              <input
                className="form-control form-control-solid d-inline-block w-auto"
                type="text"
                placeholder="Поиск ЗИП..."
                value={this.state.textSearchValue || ""}
                onChange={(e) => this.handleSearch(e.target.value)}
              />
              {this.state.textSearchValue && !this.state.searchPending ? (
                <div className="input-group-append">
                  <button
                    title="Отменить поиск"
                    className="btn btn-icon btn-secondary"
                    type="button"
                    onClick={() => this.handleSearchCancell()}
                  >
                    <i className="fa text-muted fa-close"></i>
                  </button>
                </div>
              ) : null}
              {this.state.searchPending ? (
                <div className="input-group-append">
                  <div className="btn btn-icon btn-light">
                    <div className="spinner mr-5"></div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div>{this.props.extraButtons}</div>
        </div>

        {/*filters*/}

        <List
          listKey="modeldsList"
          key={this.state.customListKey}
          fulltext={JSON.stringify(this.state.search)}
          search={JSON.stringify(
            this.state.filters.active.concat(this.state.filters.default)
          )}
          sort={JSON.stringify(this.state.sortings.active)}
          fields={JSON.stringify(this.state.fields.active)}
          limit={this.props.limit || 100}
          hideSinglePageNav={true}
          keyField="id"
          path="/model/list"
          row={this.state.viewGrid}
          onLoadStart={this.onListLoadStart}
          onLoadEnd={this.onListLoadEnd}
          blocker={{ spinnerFixed: true, hAuto: true }}
        >
          <ModelListItem
            highlightItem={this.props.modelId}
            categoryId={this.props.categoryId}
            onModelPick={this.props.onModelPick}
            onModelCheck={this.props.onModelCheck}
            checkedModels={this.props.checkedModels || []}
          />
        </List>
      </>
    );
  }
}
